import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from '../api';

const MESES = ['', 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

function clp(n) {
  return `$${Number(n || 0).toLocaleString('es-CL')}`;
}

export default function DashboardPage() {
  const { cid } = useParams();
  const now = new Date();
  const [periodo, setPeriodo] = useState(`${now.getFullYear()}-${now.getMonth() + 1}`);
  const [resumen, setResumen] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!cid) return;
    localStorage.setItem('gc_condominio_id', cid);
    setError('');
    api
      .get(`/gastos-comunes/condominios/${cid}/resumen`, { params: { periodo } })
      .then((r) => setResumen(r.data))
      .catch((e) => setError(e.response?.data?.error || e.message));
  }, [cid, periodo]);

  const [anio, mes] = periodo.split('-').map(Number);

  return (
    <>
      <h1 className="page-title">Resumen</h1>
      {error && <div className="alert alert-error">{error}</div>}

      <div className="resumen-toolbar">
        <label className="resumen-periodo">
          Mes
          <input value={periodo} onChange={(e) => setPeriodo(e.target.value)} placeholder="2026-10" />
        </label>
      </div>

      {resumen && (
        <>
          <div className="resumen-hero">
            <div className="resumen-hero-item resumen-ingreso">
              <span>Ingresos (caja)</span>
              <strong>{clp(resumen.ingresosCajaMes)}</strong>
            </div>
            <div className="resumen-hero-item resumen-egreso">
              <span>Egresos pagados</span>
              <strong>{clp(resumen.egresosPagadosMes)}</strong>
            </div>
            <div className="resumen-hero-item resumen-neto">
              <span>Resultado del mes</span>
              <strong>{clp(resumen.flujoNetoMes)}</strong>
            </div>
          </div>

          <div className="card card-flat">
            <h3 className="card-title-sm">Cobranza del mes</h3>
            <ul className="resumen-list">
              <li>
                <span>Cobrado a cargos</span>
                <strong>{clp(resumen.cobradoSobreCargos)}</strong>
              </li>
              <li>
                <span>Pendiente en cargos</span>
                <strong>{clp(resumen.pendienteCargos)}</strong>
              </li>
            </ul>
            <p className="resumen-hint">
              {MESES[resumen.periodo?.mes || mes]} {resumen.periodo?.anio || anio} ·{' '}
              <Link to={`/c/${cid}/cobranza`}>Ingresos</Link>
              {' · '}
              <Link to={`/c/${cid}/egresos`}>Registrar egreso</Link>
            </p>
          </div>
        </>
      )}
    </>
  );
}
